<template>
  <!-- 
    name: 覃刚
    function: 原料数据库-新增
    date: 2021-03-15
 -->
  <div>
    <div class="nurientHead">
      <div class="right">
        <a-cascader :field-names="{ label: 'name', value: 'name', children: 'children' }" v-model="typeArr"
          :options="typeList" :load-data="loadData" placeholder="请选择指标类型" change-on-select
          style="width: 180px;margin-right: 20px" @change="changeType" />
      </div>
    </div>
    <a-table :columns="renderColumns(columns)" bordered :data-source="list" class="tableBox" :pagination="false"
      :scroll="{ x: 600, y: 350 }">
      <span slot="customTitle"><a-icon @click="fixedCol" type="pushpin" :theme="filled ? 'filled' : 'outlined'" />
        指标类型</span>
      <span slot="sort" slot-scope="t,r,index">{{ index + 1 }}</span>
      <span slot="difference" slot-scope="t,record">
        <span style="color:red"
          v-if="(Number(((record.culationValue || 0) - (record.nutritionValue || 0)).toFixed(precision['culationValue'] || 4)) > 0) && (record.culationValue || record.nutritionValue)">+{{
          ((record.culationValue || 0)
          - (record.nutritionValue || 0)).toFixed(precision['culationValue'] || 4)}}</span>

        <span style="color:rgba(0, 0, 0, 0.65)"
          v-if="(Number(((record.culationValue || 0) - (record.nutritionValue || 0)).toFixed(precision['culationValue'] || 4)) === 0) || (!record.nutritionValue && !record.culationValue)">-</span>

        <span style="color:green"
          v-if="(Number(((record.culationValue || 0) - (record.nutritionValue || 0)).toFixed(precision['culationValue'] || 4)).toFixed(precision['culationValue'] || 4) < 0) && (record.culationValue || record.nutritionValue)">{{
          ((record.culationValue || 0)
          - (record.nutritionValue || 0)).toFixed(precision['culationValue'] || 4)}}</span>
      </span>
      <div slot="culationValue" slot-scope="t,record">
        <span v-if="calculateValueReadOnly || !record.edit">{{ t || t === 0 ? t.toFixed(precision['culationValue'] || 4) : t
          }}</span>
        <a-input-number v-else style="width: 100%" ref="getFocus" :precision="precision['culationValue'] || 4"
          :max="9999999999" :min="-9999999999" @blur="saveList(record)" @pressEnter="saveList(record)"
          :step="Math.pow(0.1, precision['culationValue'] || 4).toFixed(precision['culationValue'] || 4)"
          v-model="inputVal" />
      </div>
      <span slot="nutritionValue" slot-scope="t">{{ t || t === 0 ? t.toFixed(precision['nutritionValue'] || 4) : t
        }}</span>
      <a-tooltip slot="typeName" slot-scope="text,record">
        <template slot="title">
          {{ overseasFlag == '1' ? (record.aliasName || text) : text }}
        </template>
        <span class="nameStyle">{{ overseasFlag == '1' ? (record.aliasName || text) : text }}</span>
      </a-tooltip>
    </a-table>
  </div>
</template>
<script>
export default {
  props: {
    typeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    calculationList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      calculateValueReadOnly: this.viewOnly,
      overseasFlag: window.localStorage.getItem("overseasFlag"),
      precision: this.$store.state.precision,
      recordObj: {},
      inputVal: '',
      name: 'ddd',
      typeArr: [],
      priceField: 'privateContractPrice',
      form: this.$form.createForm(this),
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1
      },
      formData: {
        name: '',
        typeid: '',
        price: ''
      },
      selectList: [],
      selectId: [],
      list: [],
      columnsAll: [
        // {
        //   title: '指标类型',
        //   dataIndex: 'sort',
        //   scopedSlots: { customRender: 'sort' },
        //   width: 80,
        //   ellipsis: true,
        // },
        {
          // title: '指标类型',
          dataIndex: 'typeName',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'typeName' },
          slots: { title: 'customTitle' },
        },
        {
          title: '代码',
          dataIndex: 'code',
          width: 120,
          ellipsis: true,
        },
        {
          title: '指标名称',
          dataIndex: 'name',
          width: 140,
          ellipsis: true,
        },
        {
          title: '全称',
          dataIndex: 'fullName',
          width: 150,
          ellipsis: true,
          // scopedSlots: { customRender: 'price' },
        },
        {
          title: '原先值',
          dataIndex: 'nutritionValue',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'nutritionValue' },
          sorter: (a, b) => a.nutritionValue - b.nutritionValue,
        },
        {
          title: '计算值',
          dataIndex: 'culationValue',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'culationValue' },
          sorter: (a, b) => a.culationValue - b.culationValue,
        },
        {
          title: '差异',
          dataIndex: 'difference',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'difference' },
          sorter: (a, b) => Number((a.culationValue || 0) - (a.nutritionValue || 0)) - Number((b.culationValue || 0) - (b.nutritionValue || 0)),
        },
        {
          title: '计量单位',
          dataIndex: 'unit',
          width: 100,
          ellipsis: true,
        }
      ],
      filled: false
    };
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, rowkey) => {
          this.selectList = selectedRowKeys;
          rowkey.forEach(el => {
            if (!this.selectId.includes(el.id)) this.selectId.push(el.id);
          });
        },
        selectedRowKeys: this.selectList
      };
    },
    columns() {
      let columns = [...this.columnsAll];
      if (this.filled) {
        columns[0].fixed = 'left';
      } else {
        delete columns[0].fixed;
      }
      return columns;
    }
  },
  mounted() {
    this.list = [...this.calculationList];
  },
  methods: {
    fixedCol(e) {
      this.filled = !this.filled;
      e = e || window.event;
      if (e.stopPropagation) { //W3C阻止冒泡方法  
        e.stopPropagation();
      } else {
        e.cancelBubble = true; //IE阻止冒泡方法  
      }
    },
    renderColumns(columns) {
      return columns.map(item => {
        if (item.dataIndex === 'culationValue') {
          return {
            ...item,
            customCell: (record) => {
              return {
                on: {
                  click: () => {
                    if (this.recordObj.code) return;
                    this.inputVal = record[item.dataIndex];
                    // this.editRow(record,'edit')
                    record.edit = true;
                    this.recordObj = record;
                    setTimeout(() => {
                      this.$refs.getFocus.focus();
                    }, 0);
                  },
                },
                style: {
                  background: '#e6f7ff'
                }
              };
            }
          };
        } else {
          return item;
        }
      });
    },
    conversion(val, record) {
      console.log(val, record, this.inputVal);
      // let DM = this.calculationList.filter(el => el.name === 'DM')[0] || {}
      // let Moisture = this.calculationList.filter(el => el.name === 'Moisture')[0] || {}
      // if(record.name === 'DM'){
      //   let Moisture2 = this.list.filter(el => el.name === 'Moisture')[0] || {}
      //   DM.culationValue = val
      //   Moisture.culationValue = 100 - val

      //   Moisture2.culationValue = 100 - val
      //   // record
      // }
      // if(record.name === 'Moisture'){
      //   let DM2 = this.list.filter(el => el.name === 'DM')[0] || {}
      //   Moisture.culationValue = val
      //   DM.culationValue = 100 - val

      //   DM2.culationValue = 100 - val
      // record
      // }
    },
    saveList(record) {
      record.edit = false;
      this.recordObj = {};
      let newList = this.list.filter(el => (el.name === 'DM' || el.name === 'Moisture'));
      if (record.name === 'DM' || record.name === 'Moisture') {
        if (this.inputVal === '' || this.inputVal === undefined || this.inputVal === null) {
          newList.map(el => {
            if (record.name !== el.name) {
              el.culationValue = 100;
            } else {
              el.culationValue = 0;
            }
            return el;
          });
        } else {
          newList.map(el => {
            if (record.name !== el.name) {
              el.culationValue = 100 - this.inputVal;
            } else {
              el.culationValue = this.inputVal;
            }
            return el;
          });
        }
      } else {
        record.culationValue = this.inputVal;
      }

    },

    changeType(value) {
      if (value.length > 0) {
        let id = value[value.length - 1];
        let newList = this.calculationList.filter(e => e.typeName === id);
        this.list = [...newList];
      } else {
        this.list = [...this.calculationList];
      }
      // if(value && value.length > 0){
      //   this.formData.typeId = value[value.length - 1]
      // }else{
      //   this.formData.typeId = undefined
      // }
      // this.getList(this.pagination)
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        this.$emit('getTypeList', { targetOption, id: targetOption.id });
        // this.getTypeList(targetOption.id,targetOption) || []
        // this.typeList = [...this.typeList];
      }, 0);
    },
    onSearch() {
      this.getList(this.pagination);
    },
    getList(pagination) {
      this.selectList = [];
      let { current = 1, size = 10 } = pagination || {};
      let factoryId = window.localStorage.getItem('factoryId');
      let params = {
        ...this.formData,
        current, size, factoryId
      };
      this.$http.get('/nhf-app/factoryRaw/page', { params }).then(res => {
        let { success, data } = res;
        if (success) {
          let { records, current = 1, total = 0 } = data;
          this.pagination.current = current;
          this.pagination.total = total;
          this.list = records || [];
        } else {
          this.$message.error('查询失败');
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.nurientHead {
  display: flex;

  .left,
  .right {
    width: 40%;
    display: flex;
  }

  .middle {
    width: 20%;
  }
}

.tableBox {
  padding: 0;
  margin-top: 20px;
  // max-height: 500px;
  overflow-y: auto;
}
</style>